import React from "react";
import { withRouter } from "react-router-dom";

import WelcomeScreen from "components/WelcomeScreen";

import { tracker } from "library/tracker";
import { pushNotification } from "library/pushNotification";

import { config } from "config";

const SLIDE_TRACKERS = [
  null,
  tracker.beforeRegistration.splashVideo1,
  tracker.beforeRegistration.splashVideo2,
  tracker.beforeRegistration.splashVideo3,
  tracker.beforeRegistration.splashVideo4,
];

class AppWelcomeScreenContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trackedSlides: {},
    };

    this.onSlideView = this.onSlideView.bind(this);
    this.onComplete = this.onComplete.bind(this);
  }

  componentDidMount() {
    if (this.props.isAppWelcomeScreenShown || !config.isMobileApp) {
      this.props.history.replace("/login");
    }

    tracker.beforeRegistration.appDownload({
      device_id: this.props.deviceId,
      campaign: "",
      platform: "",
    });

    tracker.beforeRegistration.spalshVideo({ device_id: this.props.deviceId });

    document.querySelector("html").classList.add("app-welcome-screen");

    pushNotification.init();

    this.onSlideView(0);
  }

  componentWillUnmount() {
    document.querySelector("html").classList.remove("app-welcome-screen");
  }

  onSlideView(index) {
    if (this.state.trackedSlides[index]) {
      return;
    }

    const trackSlide = SLIDE_TRACKERS[index];
    if (trackSlide) {
      trackSlide({ device_id: this.props.deviceId });
    }

    this.setState((prevState) => ({
      trackedSlides: {
        ...prevState.trackedSlides,
        [index]: true,
      },
    }));
  }

  onComplete() {
    pushNotification.ensurePermission({ openSettingsIfDenied: true });
    this.props.setAppWelcomeScreenShownAction();
    this.props.history.replace("/signup");
  }

  render() {
    return (
      <WelcomeScreen onComplete={this.onComplete} onSlideView={this.onSlideView} />
    );
  }
}

export default withRouter(AppWelcomeScreenContainer);
